import { rest } from 'msw'
import base64Pdf from '!url-loader!../data/7a79c35f7ce0704dec63be82440c8182.pdf'

export default [
  /**
   * テクニカルレポート
   */
  rest.get('/swc-api/nodes/:nodeId/technical-reports/', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "2022年01月の稼働状況レポート",
        "attachment_files":[
        {
        "id": 1,
        "file_name": "2022年01月の稼働状況"
        },
        {
        "id": 2,
        "file_name": "2022年02月の稼働状況"
        }
        ]
        },
        {
        "id": 2,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-01-05",
        "title": "2021年12月の稼働状況レポート",
        "attachment_files":[]
        }
        ]
        ),
    )
  }),

  /**
   * テクニカルレポート
   */
  rest.get('/swc-api/nodes/:nodeId/technical-reports/:technicalReportId', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "2022年01月の稼働状況レポート",
        "attachment_files":[
        {
        "id": 1,
        "file_name": "2022年01月の稼働状況"
        }
        ]
        })
        )
      }),

  /**
   * テクニカルレポート
   */
   rest.post('/swc-api/nodes/:nodeId/technical-reports/', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "2022年01月の稼働状況レポート",
        "attachment_files":[
        {
        "id": 1,
        "file_name": "2022年01月の稼働状況"
        }
        ]
        })
        )
      }),

  /**
   * テクニカルレポート
   */
   rest.put('/swc-api/nodes/:nodeId/technical-reports/:technicalReportId', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "2022年01月の稼働状況レポート",
        "attachment_files":[
        {
        "id": 1,
        "file_name": "2022年01月の稼働状況"
        }
        ]
        })
        )
      }),

  /**
   * テクニカルレポート
   */
   rest.patch('/swc-api/nodes/:nodeId/technical-reports/:technicalReportId', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "2022年01月の稼働状況レポート",
        "attachment_files":[
        {
        "id": 1,
        "file_name": "2022年01月の稼働状況"
        }
        ]
        })
        )
      }),

  /**
   * テクニカルレポートダウンロード
   */
  rest.get('/swc-api/nodes/:nodeId/technical-reports/:technical_report_id/attachments/:id', async (req, res, ctx) => {
    // Convert "base64" image to "ArrayBuffer".
    const imageBuffer = await fetch(base64Pdf).then((res) =>
      res.arrayBuffer(),
    )

    return res(
      ctx.set('Content-Length', imageBuffer.byteLength.toString()),
      ctx.set('Content-Type', 'application/pdf'),
      // Respond with the "ArrayBuffer".
      ctx.body(imageBuffer),
    )
   })

]
